<template>
  <div>
    <v-row class="mx-2">
      <!-- <v-col cols="12" md="6" class="flex-items">
            <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
              <v-tab v-for="tab in tabList" :key="tab.id" @click="changeTab(tab)">{{
                tab.name
              }}</v-tab>
            </v-tabs>
          </v-col> -->
      <v-spacer></v-spacer>
      <v-col cols="12" md="6" class="d-flex justify-space-between">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="search"
          label="Search"
          single-line
          hide-details
          class="rounded-lg"
          color="#239FAB"
          dense
        ></v-text-field>
        <v-btn
          class="white--text ml-2 rounded-lg"
          :color="$vuetify.theme.themes.light.submitBtns"
          @click="add()"
        >
          <v-icon left> mdi-plus-box-outline </v-icon>
          Add New
        </v-btn>
      </v-col>
    </v-row>
    <v-card class="ma-5 dt-container" elevation="0" outlined>
      <v-data-table
        :headers="headers"
        :items="data"
        :items-per-page="10"
        :search="search"
        :options.sync="options"
        :loading="loading"
        @pagination="pagination"
        hide-default-footer
      >
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            class="ma-1"
            x-small
            color="green"
            outlined
            @click="viewItem(item)"
          >
            View
          </v-btn>

          <v-btn
            class="ma-1"
            x-small
            color="warning"
            outlined
            @click="updateItem(item)"
          >
            Update
          </v-btn>
          <v-btn
            v-if="item.year == getCurrentYear"
            class="ma-1"
            x-small
            color="red"
            outlined
            @click="deleteItem(item)"
          >
            Delete
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-row class="mb-2 mx-5" align="center">
      <v-col cols="auto" class="mr-auto text-truncate flex-items" no-gutters>
        <span class="px-2">Show</span>
        <span>
          <v-select
            dense
            outlined
            color="#519043"
            hide-details
            :value="options.itemsPerPage"
            style="max-width: 90px"
            class="rounded-lg"
            @change="options.itemsPerPage = parseInt($event, 10)"
            :items="perPageChoices"
          >
          </v-select>
        </span>
        <span class="px-2"> Entries </span>
      </v-col>

      <v-col cols="auto" class="mr-auto text-truncate" no-gutters>
        Showing {{ paginationData.pageStart + 1 }} to
        {{ paginationData.pageStop }} of
        {{ paginationData.itemsLength }} entries
      </v-col>
      <v-col cols="auto">
        <v-pagination
          v-model="options.page"
          class="rounded-lg"
          :total-visible="7"
          :color="$vuetify.theme.themes.light.submitBtns"
          :length="paginationData.pageCount"
        >
        </v-pagination>
      </v-col>
    </v-row>

    <!-- delete dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
              Are you sure you want to proceed?
            </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()">
            Close
          </v-btn>
          <v-btn
            color="green"
            class="white--text"
            :disabled="btnLoading"
            :loading="btnLoading"
            @click="confirmDelete()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <OPCRSFUtilDialog :data="opcrData" :action="action" />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="5000"
    ></fade-away-message-component>
  </div>
</template>
<script>
export default {
  components: {
    OPCRSFUtilDialog: () =>
      import("../../components/Dialogs/Forms/OPCR/OPCRSFUtilDialog.vue"),
  },
  data: () => ({
    confirmDialog: false,
    itemToDelete: null,
    btnLoading: false,
    search: "",
    fullname: null,
    opcrData: null,
    opcrSupData: null,
    headers: [
      {
        text: "Year",
        value: "year",
        align: "start",
        valign: "center",
        sortable: false,
      },

      {
        text: "MFO",
        value: "mfo",
        align: "start",
        valign: "center",
        sortable: false,
      },

      {
        text: "Success Indicator",
        value: "success_indicator",
        align: "start",
        valign: "center",
        sortable: false,
      },

      // {
      //   text: "Actual Accomplishment",
      //   value: "actual_accom",
      //   align: "start",
      //   valign: "center",
      //   sortable: false,
      // },

      {
        text: "Action",
        value: "action",
        align: "center",
        sortable: false,
      },
    ],

    data: [],

    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],

    loading: false,
    options: {},
    action: null,
    paginationData: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
    yearList: [],
  }),

  mounted() {
    this.eventHub.$on("closeViewOPCRSupportFunctionRatingDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeOPCRSFUtilDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeViewOPCRSupportFunctionRatingDialog");
    this.eventHub.$off("closeOPCRSFUtilDialog");
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    filterYear: {
      handler(newData, oldData) {
        if (oldData != newData) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
  computed: {
    filterYear() {
      return this.$store.getters.getFilterSelected;
    },

    getCurrentYear() {
      let d = new Date();
      return d.getFullYear();
    },
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },

    initialize() {
      this.axiosCall("/opcr-support-util/" + this.filterYear, "GET").then(
        (res) => {
          if (res) {
            this.data = res.data;
            this.loading = false;
          }
        }
      );
    },

    add() {
      this.opcrData = { id: null };
      this.action = "Add";
    },

    getStatus(type, item) {
      let toReturn = "";
      if (type == "assess") {
        if (item.isSubmitted == 0) {
          toReturn = "For Submission";
        } else {
          if (item.assesed_by_status == 1) {
            toReturn = "For Approval";
          } else if (item.assesed_by_status == 2) {
            toReturn = "Approved";
          } else if (item.assesed_by_status == 3) {
            toReturn = "Pending";
          }
        }
      } else if (type == "final_rating") {
        if (item.isSubmitted == 0) {
          toReturn = "For Submission";
        } else {
          if (item.final_rating_by_status == null) {
            toReturn = "For Submission";
          } else if (item.final_rating_by_status == 1) {
            toReturn = "For Approval";
          } else if (item.final_rating_by_status == 2) {
            toReturn = "Approved";
          } else if (item.final_rating_by_status == 3) {
            toReturn = "Pending";
          }
        }
      }
      return toReturn;
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },

    viewItem(item) {
      this.opcrData = item;
      this.action = "View";
    },

    updateItem(item) {
      this.opcrData = item;
      this.action = "Update";
    },

    deleteItem(item) {
      this.btnLoading = false;
      this.itemToDelete = item;
      this.confirmDialog = true;
    },

    confirmDelete() {
      this.btnLoading = true;
      this.axiosCall(
        "/opcr-support-util/" + this.itemToDelete.id,
        "DELETE"
      ).then((res) => {
        if (res) {
          console.log("delete", res);
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
          this.confirmDialog = false;
          this.btnLoading = false;
          this.initialize();
        }
      });
    },

    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
      this.btnLoading = false;
    },
  },
};
</script>
